import { createContext, useContext, useState, useCallback } from 'react';
import ScanQrUpdateStatusModal from '../components/shipment-qr-status/ScanQrUpdateStatusModal.js';

const ScanQrModalContext = createContext(null);

export const ScanQrModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [preferStatus, setPreferStatus] = useState('');

  const openScanQrModal = useCallback((options = {}) => {
    setPreferStatus(String(options.preferStatus || '').trim());
    setIsOpen(true);
  }, []);
  const closeScanQrModal = useCallback(() => {
    setIsOpen(false);
    setPreferStatus('');
  }, []);

  return (
    <ScanQrModalContext.Provider value={{ openScanQrModal, closeScanQrModal, isOpen, preferStatus }}>
      {children}
      <ScanQrUpdateStatusModal
        isOpen={isOpen}
        onClose={closeScanQrModal}
        preferStatus={preferStatus}
      />
    </ScanQrModalContext.Provider>
  );
};

export const useScanQrModal = () => {
  const ctx = useContext(ScanQrModalContext);
  if (!ctx) {
    return {
      openScanQrModal: () => {},
      closeScanQrModal: () => {},
      isOpen: false,
      preferStatus: '',
    };
  }
  return ctx;
};
